import React from "react";
import { useTranslation } from "@helpers/translate";
import TradeArrowUpIcon from "@assets/icons/TradeArrowUpIcon";
import TradeArrowDownIcon from "@assets/icons/TradeArrowDownIcon";
import "./index.sass";

export const TradeButtons = ({ onSelect, disabled = false }) => {
  const { __ } = useTranslation();

  return (
    <div className="trade-buttons">
      <button
        type="button"
        className="trade-btn trade-btn--long"
        disabled={disabled}
        onClick={() => onSelect("long")}
      >
        <TradeArrowUpIcon className="trade-btn__icon" color="currentColor" />
        {__("futures.long")}
      </button>

      <button
        type="button"
        className="trade-btn trade-btn--short"
        disabled={disabled}
        onClick={() => onSelect("short")}
      >
        <TradeArrowDownIcon className="trade-btn__icon" color="currentColor" />
        {__("futures.short")}
      </button>
    </div>
  );
};

export default TradeButtons;
